import React, { useState } from "react";

// The editable hourly rate shared by voice_time_saved and chat_deflection.
//
// Changing it RE-FIRES fn_get_agent_value with p_hourly_rate; the new figure
// comes back from the database. Nothing here multiplies — Part F forbids a
// component computing a metric, and a client-side `hours * rate` would drift
// from whatever the function actually does the moment its basis changes.
//
// The rate is an input, not a measurement, so it sits below the figures rather
// than in their row.
const HourlyRateControl = ({ id, defaultRate, note, saving, onCommit }) => {
  const [rate, setRate] = useState("");
  return (
    <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800">
      <label className="flex items-center gap-2 flex-wrap" htmlFor={id}>
        <span className="gi-label text-gray-500 dark:text-gray-400">Hourly rate</span>
        <span className="relative">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-sm text-gray-500 dark:text-gray-400">$</span>
          <input
            id={id}
            type="number"
            min="0"
            value={rate}
            placeholder={defaultRate != null ? String(defaultRate) : ""}
            onChange={(e) => setRate(e.target.value)}
            onBlur={() => { const n = Number(rate); if (rate && !Number.isNaN(n) && n > 0) onCommit(n); }}
            aria-label="Hourly rate in dollars"
            className="w-24 max-md:min-h-[44px] rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 pl-5 pr-2.5 py-1.5 text-sm disabled:opacity-60"
            disabled={saving}
          />
        </span>
        {saving && <span className="gi-label text-gray-500 dark:text-gray-400">Recalculating…</span>}
      </label>
      {/* The backend's own words on why this control exists. */}
      {note && <p className="gi-label text-gray-500 dark:text-gray-400 mt-2">{note}</p>}
    </div>
  );
};

export default HourlyRateControl;
